import { useState, useRef } from "react";

export const usePasswordVisibility = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const togglePasswordVisibility = () => {
    const input = inputRef.current;
    let selectionStart = 0;
    let selectionEnd = 0;
    if (input) {
      selectionStart = input.selectionStart || 0;
      selectionEnd = input.selectionEnd || 0;
    }
    setIsPasswordVisible(prev => !prev);
    setTimeout(() => {
      if (input) {
        input.setSelectionRange(selectionStart, selectionEnd);
      }
    }, 0);
  };

  return {
    isPasswordVisible,
    togglePasswordVisibility,
    inputRef,
  };
};
